<div class="prosuite-vendor-quote-dialog">
  <!-- Enhanced Dialog Header with ProSuite Design System -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="header-content">
      <h2>{{vendorQuoteId ? 'Edit' : 'Add'}} Vendor Quote</h2>
      <p class="dialog-subtitle">
        {{vendorQuoteId ? 'Update vendor quote details' : 'Create a new vendor quote for this job'}}
      </p>
    </div>
    <button class="close-btn" (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content Wrapper -->
  <div class="dialog-content-wrapper">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
      <div class="tab-item"
        [class.active]="activeTab === 'information'"
        (click)="switchTab('information')">
        <span>Information</span>
      </div>
      <div class="tab-item"
        [class.active]="activeTab === 'uploads'"
        (click)="switchTab('uploads')">
        <span>Uploads</span>
      </div>
    </div>

    <div class="dialog-content" [formGroup]="vendorQuoteForm">

      <!-- TAB 1: INFORMATION -->
      @if (activeTab === 'information') {
        <div class="tab-content">
          <!-- Module Selection Section (for Vendor Module) -->
          @if (isVendorModule) {
            <div class="module-selection-section">
              <div class="section-header">
                <mat-icon class="section-icon">business_center</mat-icon>
                <span class="section-title">Select Module Type</span>
              </div>
              <div class="module-toggle-container">
                <mat-button-toggle-group name="moduleType" aria-label="Module Type Selection" [(value)]="moduleId"
                  (change)="onModuleSelect($event)" class="module-toggle-group">
                  <mat-button-toggle [value]="19" class="module-toggle">
                    <mat-icon>work</mat-icon>
                    <span>Job</span>
                  </mat-button-toggle>
                  <mat-button-toggle [value]="16" class="module-toggle">
                    <mat-icon>request_quote</mat-icon>
                    <span>Bid</span>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>
            <!-- Job/Bid Selection -->
            <div class="form-field-container full-width">
              <label class="form-label" for="module-reference">
                <mat-icon class="label-icon">{{this.moduleId===19 ? 'work' : 'request_quote'}}</mat-icon>
                {{this.moduleId===19 ? 'Job' : 'Bid'}} Reference
              </label>
              <div class="form-group enhanced-form-group">
                <!-- JOB Dropdown -->
                @if (this.moduleId===19) {
                  <app-scrollable-search-field style="width: 100%;" id="job-reference"
                    [dataService]="jobDataService" [dataServiceFunctionName]="'search'" [searchPlaceHolder]="'Select Job'"
                    [labelKey]="'job_name'"
                    [formDataMapper]="{'id': 'id', 'name' : 'company_name', 'contacts' : 'contacts','primary_contact': 'primary_contact'}"
                    [keyNameToShowWhenSelected]="'name'" (selectedValueChange)="selectedModuleChangeValue($event)"
                    [showError]="false" [sortOrder]="'desc'" aria-label="Select job reference">
                  </app-scrollable-search-field>
                }
                <!-- Bid Dropdown -->
                @if (this.moduleId===16) {
                  <app-scrollable-search-field style="width: 100%;" id="bid-reference"
                    [dataService]="bidDataService" [dataServiceFunctionName]="'search'" [searchPlaceHolder]="'Select Bid'"
                    [labelKey]="'name'"
                    [formDataMapper]="{'id': 'id', 'name' : 'company_name', 'contacts' : 'contacts','primary_contact': 'primary_contact'}"
                    [keyNameToShowWhenSelected]="'name'" (selectedValueChange)="selectedModuleChangeValue($event)"
                    [showError]="false" [sortOrder]="'desc'" aria-label="Select bid reference">
                  </app-scrollable-search-field>
                }
              </div>
            </div>
          }
          <!-- Main Form Section -->
          <div class="form-section">
            <div class="section-header">
              <mat-icon class="section-icon">description</mat-icon>
              <span class="section-title">Quote Details</span>
              <span class="section-subtitle">Enter vendor quote information</span>
            </div>
            <div class="form-grid">
              <!-- Vendor Selection (Non-Vendor Module) -->
              @if (!isVendorModule) {
                <div class="form-field-container full-width">
                  <label class="form-label required" for="vendor">
                    <mat-icon class="label-icon">business</mat-icon>
                    Vendor
                  </label>
                  <div class="input-with-action">
                    <app-scrollable-search-field [disabled]="isVendorDisabled" style="width: 100%;" class="flex-grow"
                      id="vendor" [dataService]="vendorDataService" [dataServiceFunctionName]="'search'"
                      [searchPlaceHolder]="'Select Vendor'" [labelKey]="'name'"
                      [formDataMapper]="{'id': 'id', 'name' : 'company_name', 'contacts' : 'contacts','primary_contact': 'primary_contact'}"
                      [keyNameToShowWhenSelected]="'name'" (selectedValueChange)="selectedValueChange($event)"
                      [showError]="false" [sortOrder]="'desc'" [inputVal]="vendorDetail ? vendorDetail.name : ''"
                      aria-label="Select vendor" aria-required="true">
                    </app-scrollable-search-field>
                    @if (!isVendorDisabled) {
                      <button mat-mini-fab
                        color="accent"
                        class="add-vendor-btn"
                        (click)="createVendor()"
                        aria-label="Add new vendor"
                        matTooltip="Add new vendor">
                        <mat-icon>add</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
              <!-- Quote Details Row - Three Fields in One Line -->
              <div class="form-field-container full-width">
                <div class="three-column-row">
                  <!-- Quote Reference Number -->
                  <div class="column">
                    <label class="form-label required" for="quotation_reference">
                      <mat-icon class="label-icon">tag</mat-icon>
                      Vendor Quote #
                    </label>
                    <input type="text"
                      class="form-control enhanced-input"
                      name="quotation_reference"
                      id="quotation_reference"
                      formControlName="quotation_reference"
                      placeholder="Enter quote number"
                      aria-label="Vendor quote number"
                      aria-required="true">
                    <app-validation-error [formGroup]="vendorQuoteForm" [controlName]="'quotation_reference'" [message]="'Vendor Quote # is required'"></app-validation-error>
                  </div>
                  <!-- Total Quote Amount -->
                  <div class="column">
                    <label class="form-label required" for="amount">
                      <mat-icon class="label-icon">attach_money</mat-icon>
                      Total Quote Amount
                    </label>
                    <div class="input-with-prefix">
                      <span class="input-prefix">$</span>
                      <input type="text"
                        currencyMask
                        autocomplete="off"
                        [max]="99999999.99"
                        [options]="currencyMaskOptions"
                        class="form-control enhanced-input with-prefix"
                        name="amount"
                        id="amount"
                        formControlName="amount"
                        placeholder="0.00"
                        aria-label="Total quote amount"
                        aria-required="true">
                    </div>
                    <app-validation-error [formGroup]="vendorQuoteForm" [controlName]="'amount'" [message]="'Total Quote Amount is required'"></app-validation-error>
                  </div>
                  <!-- Quote Valid Till -->
                  <div class="column">
                    <label class="form-label required" for="valid_till">
                      <mat-icon class="label-icon">event</mat-icon>
                      Quote Valid Till
                    </label>
                    <div class="date-picker-wrapper">
                      <input type="text"
                        id="valid_till"
                        formControlName="valid_till"
                        class="form-control enhanced-input date-input"
                        [matDatepicker]="open_till"
                        placeholder="Select date"
                        aria-label="Quote validity date"
                        aria-required="true">
                      <mat-datepicker-toggle
                        class="date-picker-toggle"
                        matIconSuffix
                        [for]="open_till">
                      </mat-datepicker-toggle>
                      <mat-datepicker #open_till></mat-datepicker>
                    </div>
                    <app-validation-error [formGroup]="vendorQuoteForm" [controlName]="'valid_till'" [message]="'Quote Valid Till is required'"></app-validation-error>
                  </div>
                </div>
              </div>
              <!-- Scopes Selection -->
              <div class="form-field-container full-width">
                <label class="form-label required" for="scopes">
                  <mat-icon class="label-icon">category</mat-icon>
                  Scopes
                </label>
                <ng-select
                  id="scopes"
                  [items]="scopes"
                  placeholder="Select Scopes"
                  [closeOnSelect]="true"
                  [multiple]="true"
                  formControlName="scopes"
                  bindLabel="name"
                  class="enhanced-select"
                  (change)="onScopeChange($event)"
                  aria-label="Select scopes">
                </ng-select>
                <app-validation-error [formGroup]="vendorQuoteForm" [controlName]="'scopes'" [message]="'Scopes is required'"></app-validation-error>
              </div>
              <!-- Materials/Products Section -->
              <div class="form-field-container full-width">
                <div class="materials-header">
                  <label class="form-label" for="materials">
                    <mat-icon class="label-icon">inventory_2</mat-icon>
                    Items
                    <span class="label-optional">(Optional)</span>
                  </label>
                  <!-- Add Item Buttons -->
                  <div class="add-item-buttons-header">
                    <button mat-raised-button
                      color="primary"
                      type="button"
                      class="add-material-btn"
                      (click)="addItem(CONST_MATERIAL)"
                      [disabled]="!vendorQuoteForm.get('vendor_id')?.value">
                      <mat-icon>add_box</mat-icon>
                      <span>ADD MATERIAL</span>
                      <span class="keyboard-hint">(P)</span>
                    </button>
                    <button mat-raised-button
                      color="accent"
                      type="button"
                      class="add-shipping-btn"
                      (click)="addItem(CONST_SHIPPING)"
                      [disabled]="!vendorQuoteForm.get('vendor_id')?.value">
                      <mat-icon>local_shipping</mat-icon>
                      <span>ADD SHIPPING</span>
                      <span class="keyboard-hint">(H)</span>
                    </button>
                  </div>
                </div>
                <!-- Info Hint -->
                @if (!vendorQuoteForm.get('vendor_id')?.value) {
                  <div class="field-hint">
                    <mat-icon>info_outline</mat-icon>
                    <span>Select a vendor first to add items</span>
                  </div>
                }
                <!-- Items Table -->
                @if (selectedProducts && selectedProducts.length > 0) {
                  <div class="items-table-container">
                    <table class="items-table">
                      <thead>
                        <tr>
                          <th class="col-action" style="width: 40px;"></th>
                          <th class="col-item-name" style="width: 25%;">*ITEM NAME</th>
                          <th class="col-description" style="width: 25%;">DESCRIPTION</th>
                          <th class="col-qty" style="width: 10%;">QTY</th>
                          <th class="col-unit" style="width: 10%;">UNIT</th>
                          <th class="col-unit-price" style="width: 12%;">UNIT PRICE</th>
                          <th class="col-extended" style="width: 12%;">EXTENDED $</th>
                        </tr>
                      </thead>
                      <tbody class="items-table-body">
                        @for (item of selectedProducts; track item; let i = $index) {
                          <tr class="item-row">
                            <!-- Action (Remove Button) -->
                            <td class="col-action">
                              <button mat-icon-button
                                type="button"
                                class="remove-item-btn"
                                (click)="removeItem(i)"
                                matTooltip="Remove item">
                                <mat-icon class="remove-icon">close</mat-icon>
                              </button>
                            </td>
                            <!-- Item Name (Search or Display) -->
                            <td class="col-item-name">
                              <!-- Material Search (Type = 1) -->
                              @if (item.item_type === CONST_MATERIAL && !item.item_selected) {
                                <app-scrollable-search-field
                                  [dataService]="productDataService"
                                  [dataServiceFunctionName]="'search'"
                                  [additionalParams]="materialSearchParams"
                                  [skipInitialFetch]="true"
                                  [labelKey]="'full_title'"
                                  [formDataMapper]="'all'"
                                  [searchPlaceHolder]="'Type 3+ characters to search'"
                                  [appendTo]="'body'"
                                  (selectedValueChange)="onItemSelect($event, i, CONST_MATERIAL)">
                                </app-scrollable-search-field>
                              }
                              <!-- Shipping Search (Type = 4) -->
                              @if (item.item_type === CONST_SHIPPING && !item.item_selected) {
                                <app-scrollable-search-field
                                  [dataService]="proposalDataService"
                                  [dataServiceFunctionName]="'searchItems'"
                                  [additionalParams]="shippingSearchParams"
                                  [skipInitialFetch]="true"
                                  [labelKey]="'name'"
                                  [formDataMapper]="'all'"
                                  [searchPlaceHolder]="'Type to search shipping'"
                                  [appendTo]="'body'"
                                  (selectedValueChange)="onItemSelect($event, i, CONST_SHIPPING)">
                                </app-scrollable-search-field>
                              }
                              <!-- Selected Item Display -->
                              @if (item.item_selected) {
                                <div class="selected-item-display">
                                  <div class="item-info">
                                    <strong>{{item.item_name}}</strong>
                                  </div>
                                  <button mat-icon-button
                                    type="button"
                                    class="change-item-btn"
                                    (click)="changeItem(i)"
                                    matTooltip="Change item">
                                    <mat-icon class="edit-icon">edit</mat-icon>
                                  </button>
                                </div>
                              }
                            </td>
                            <!-- Description (Editable) -->
                            <td class="col-description">
                              <input type="text"
                                class="table-input"
                                [(ngModel)]="item.description"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Description">
                            </td>
                            <!-- Quantity (Editable) -->
                            <td class="col-qty">
                              <input type="number"
                                class="table-input"
                                [(ngModel)]="item.quantity"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onQuantityChange(i)"
                                min="1"
                                step="1"
                                placeholder="1">
                            </td>
                            <!-- Unit (Display Only) -->
                            <td class="col-unit">
                              <span class="unit-text">{{item.unit || '-'}}</span>
                            </td>
                            <!-- Unit Price (Display Only) -->
                            <td class="col-unit-price">
                              <span class="price-text">${{item.unit_price | number:'1.2-2'}}</span>
                            </td>
                            <!-- Extended Price (Calculated) -->
                            <td class="col-extended">
                              <span class="price-text">${{item.extended_selling | number:'1.2-2'}}</span>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <!-- End of TAB 1: INFORMATION -->

      <!-- TAB 2: UPLOADS -->
      @if (activeTab === 'uploads') {
        <div class="tab-content">
          <div class="form-section">
            <div class="form-grid">
              <!-- File Upload Section -->
              <div class="form-field-container full-width">
                <label class="form-label" for="attachments">
                  <mat-icon class="label-icon">attach_file</mat-icon>
                  Attachments
                  <span class="label-optional">(Optional)</span>
                </label>
                <!-- The system uploader: drag & drop, progress and previews, as on every other form -->
                <app-attachment
                  [dropZoneId]="'vendorQuoteAttachment'"
                  [module_id]="VENDOR_QUOTE_MODULE_ID"
                  [multipleUpload]="true"
                  [allowAllFileTypes]="true"
                  [multipleImagesOnEdit]="uploaderFiles"
                  (callback)="onAttachmentsChange($event)">
                </app-attachment>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- End of TAB 2: UPLOADS -->

    </div>
  </div>

  <!-- Dialog Footer with Action Buttons -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>

    <!-- Next Button for Information Tab -->
    @if (activeTab === 'information') {
      <button class="btn-submit" (click)="goToNextTab()">
        <mat-icon>arrow_forward</mat-icon>
        <span>Next</span>
      </button>
    }

    <!-- Submit Button for Uploads Tab -->
    @if (activeTab === 'uploads') {
      <button class="btn-submit" (click)="save()" [disabled]="vendorQuoteForm.invalid || isSaving">
        @if (isSaving) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          <mat-icon>save</mat-icon>
        }
        <span>{{ isSaving ? 'Saving...' : (vendorQuoteId ? 'Update' : 'Submit') }}</span>
      </button>
    }
  </div>
</div>
